import React from 'react'
import './OurBusiness.css'
import Notfound from '../Notfound'
export default function OurBusiness () {
  return (
    <Notfound />
  )
}